<template>
  <div>
    <vxe-form
        v-if="userData.userComp"
        ref="xForm"
        title-align="right"
        title-width="150"
        :data="formData"
        :rules="formRules"
        @submit="submit"
    >
      <vxe-form-item span="24">
        <div class="block">
          <img src="~assets/images/newUser/qyjb.png"/>
          <span>企业基本信息：</span>
          <div style="display: flex; align-items: center; margin-left: 14px;">
            <img v-if="formData.auditStatus === 0" style="width: 100%; height: 100%"
                 src="@/assets/images/common/wrz.png"/>
            <img v-if="formData.auditStatus === 1" style="width: 100%; height: 100%"
                 src="@/assets/images/common/dsh.png"/>
            <img v-if="formData.auditStatus === 2" style="width: 100%; height: 100%"
                 src="@/assets/images/common/wtg.png"/>
            <img v-if="formData.auditStatus === 3" style="width: 100%; height: 100%"
                 src="@/assets/images/common/yrz.png"/>
            <img v-if="formData.auditStatus === 4" style="width: 100%; height: 100%"
                 src="@/assets/images/common/ysx.png"/>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="营业执照:" field="businessUrl" span="24">
        <div style="height: 58px; display: flex; align-items: center">
          <upload-img v-if="isEdit && formData.auditStatus !== 3 && formData.auditStatus !== 1"
                      :row="formData" :fileKey="'businessUrl'" :width="58" :height="58" :isOcrBusiness="true"
                      :initFile="formData.businessUrl" @getOcrBusiness="getOcrBusiness"></upload-img>
          <div class="div-img"
               v-if="(isEdit && (formData.auditStatus === 3 || formData.auditStatus === 1) && formData.businessUrl) || (!isEdit && formData.businessUrl)">
            <viewer>
              <img :src="formData.businessUrl" width="58" height="58"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="企业名称:" field="compName" span="8">
        <span v-bind:class="{ active: isEdit }"
              v-if="!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3 || formData.aboutCompId != null">{{
            formData.compName
          }}</span>
        <vxe-input
            v-else-if="isEdit &&( formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
            style="width: 100%"
            v-model="formData.compName"
            placeholder="必填"
            @input="(file)=>checkCompName(file)"
        ></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="统一社会信用码:" field="taxNum" span="8">
        <vxe-input
            v-if="isEdit &&(formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
            v-model="formData.taxNum"
            placeholder="选填"
        ></vxe-input>
        <span v-bind:class="{ active: isEdit }" v-else>{{ formData.taxNum }}</span>
      </vxe-form-item>
      <vxe-form-item title="注册地址:" field="regAddr" span="8">
        <span v-if="!isEdit">{{ formData.regAddr }}</span>
        <vxe-input v-else v-model="formData.regAddr" placeholder="选填"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="注册电话:" field="regPhone" span="8">
        <span v-if="!isEdit">{{ formData.regPhone }}</span>
        <vxe-input v-else v-model="formData.regPhone" placeholder="选填"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="开户银行:" field="bankName" span="8">
        <span v-if="!isEdit">{{ formData.bankName }}</span>
        <vxe-input v-else v-model="formData.bankName" placeholder="选填"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="开户账号:" field="accountNum" span="8">
        <span v-if="!isEdit">{{ formData.accountNum }}</span>
        <vxe-input v-else v-model="formData.accountNum" placeholder="选填"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="归属区域:" field="busiOwnArea" span="8">
        <Cascader
            v-model="formData.busiOwnArea"
            :data="home_port"
            trigger="hover"
            :disabled="!isEdit"
        ></Cascader>
      </vxe-form-item>
      <vxe-form-item title="法人姓名:" field="realName" span="8">
        <template v-slot:title>
          <span style="color: #f56c6c; margin-right: 0.2em; font-family: Verdana, Arial, Tahoma">*</span>
          <span>法人姓名</span>
        </template>
        <span v-bind:class="{ active: isEdit }"
              v-if="!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3">{{ formData.realName }}</span>
        <vxe-input
            v-else-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
            v-model="formData.realName" placeholder="必填" @input="$refs.xForm.updateStatus(scope)"
        ></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="绑定手机号:" field="regisiterNum" span="8">
        <template>
          <vxe-input v-if="isEdit && formData.auditStatus !== 3" v-model="formData.regisiterNum"
                     placeholder="请输入手机号"></vxe-input>
          <span v-else>{{ formData.regisiterNum }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item span="24" v-if="formData.isShowTransportLic === 1">
        <div class="block">
          <img src="~assets/images/newUser/ysz.png"/>
          <span>运输证信息：</span>
        </div>
      </vxe-form-item>
      <vxe-form-item title="运输经营许可证：" field="transportLicenseUrl" span="8" v-if="formData.isShowTransportLic === 1">
        <div style="height: 58px; display: flex; align-items: center">
          <upload-img
              v-if="isEdit && formData.auditStatus !== 3 && formData.auditStatus !== 1"
              :row="formData"
              :fileKey="'transportLicenseUrl'"
              :width="58"
              :height="58"
              :initFile="formData.transportLicenseUrl"
          ></upload-img>
          <div class="div-img"
               v-if="(isEdit && (formData.auditStatus === 3 || formData.auditStatus === 1) && formData.transportLicenseUrl) || (!isEdit && formData.transportLicenseUrl)">
            <viewer>
              <img :src="formData.transportLicenseUrl" width="58" height="58"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="经营许可证号：" field="businessLicenseNum" span="8" v-if="formData.isShowTransportLic === 1">
        <div style="height: 58px; display: flex; align-items: center">
          <span v-bind:class="{ active: isEdit }"
                v-if="!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3">{{
              formData.businessLicenseNum
            }}</span>
          <vxe-input
              v-else-if="isEdit &&(formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
              v-model="formData.businessLicenseNum"
              placeholder="选填"
          ></vxe-input>
        </div>
      </vxe-form-item>
      <vxe-form-item title="有效期至：" field="businessExpireTime" span="8" v-if="formData.isShowTransportLic === 1">
        <div style="height: 58px; display: flex; align-items: center">
          <span v-bind:class="{ active: isEdit }"
                v-if="!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3">{{
              formData.businessExpireTime | timeFormatDate
            }}</span>
          <vxe-input
              v-else-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
              class="formInput"
              type="date"
              v-model="formData.businessExpireTime"
              placeholder="请选择日期"
          ></vxe-input>
        </div>
      </vxe-form-item>
      <vxe-form-item span="24">
        <div class="block">
          <img src="~assets/images/newUser/gly.png"/>
          <span>管理员信息：</span>
        </div>
      </vxe-form-item>
      <vxe-form-item title="管理员类型:" field="managerType" span="8">
        <span>{{ formData.realName === formData.managerName ? '法定代表人' : '非法定代表人' }}</span>
      </vxe-form-item>
      <vxe-form-item title="管理员姓名:" field="managerName" span="8">
        <template v-slot="scope">
          <span v-bind:class="{ active: isEdit }"
                v-if="!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3">{{
              formData.managerName
            }}</span>
          <vxe-input
              v-else-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
              v-model="formData.managerName"
              placeholder="选填"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="管理员身份证号:" field="managerIdcardNum" span="8">
        <template v-slot="scope">
          <span v-bind:class="{ active: isEdit }"
                v-if="!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3">{{
              formData.managerIdcardNum
            }}</span>
          <vxe-input
              v-else-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
              v-model="formData.managerIdcardNum"
              placeholder="选填"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="身份证正面:" field="managerIdcardUrlFront" span="8">
        <div style="height: 58px; display: flex; align-items: center">
          <div
              class="div-img"
              v-if="formData.managerIdcardUrlFront">
            <viewer>
              <img :src="formData.managerIdcardUrlFront" width="80" height="80"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="身份证反面:" field="managerIdcardUrlBack" span="8">
        <div style="height: 58px; display: flex; align-items: center">
          <div class="div-img"
               v-if="formData.managerIdcardUrlBack">
            <viewer>
              <img :src="formData.managerIdcardUrlBack" width="80" height="80"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
    </vxe-form>
    <div v-else style="display: flex;align-items: center;justify-content: center;margin-top: 200px;">
      <img src="~assets/images/newUser/noComp.png"/>
    </div>
    <vxe-modal v-model="compAuthVisible" title="企业认证" width="1000" height="800" resize
               position="center">
      <comp-authentication ref="compAuth" @close="compAuthVisible = false"></comp-authentication>
    </vxe-modal>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import compAuthentication from "@/views/account/compAuthentication";
import UploadImg from "@/components/common/UploadImg";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  props: ['userData'],
  components: {compAuthentication, UploadImg},
  data() {
    return {
      isEdit: false,
      formData: {},
      formRules: {},
      managerType: [
        {
          label: "法定代表人",
          value: 1,
        },
        {
          label: "非法定代表人",
          value: 2,
        },
      ],
      home_port: [],
      compAuthVisible: false,

    }
  },
  filters: {
    managerType(val) {
      if (val != null) {
        if (val === 1) {
          return "法定代表人";
        }
        if (val === 2) {
          return "非法定代表人";
        }
      }
    },
  },
  watch: {
    userData: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val.id) {
          this.formData = val.userComp;
          if(val.userComp){
            this.userId = val.userComp.id;
          }
        }
      }
    }
  },
  created() {
    this.getHomePort();
  },
  methods: {
    async getHomePort() {
      showLoading()
      let res = await $api.xcwDict.request('queryProCityAreaList');
      hideLoading();
      if (res.code === 1) {
        let province = [];
        res.data.map(i => {
          if (i.cityCodeP === '0') {
            province.push({
              label: i.cityText,
              value: i.cityCode,
              children: []
            })
          }
        })
        province.map(i => {
          res.data.map(j => {
            if (i.value === j.cityCodeP) {
              i.children.push({
                label: j.cityText,
                value: j.cityCode,
                children: []
              })
            }
          })
        })
        province.map(i => {
          i.children.map(j => {
            res.data.map(k => {
              if (j.value === k.cityCodeP) {
                j.children.push({
                  label: k.cityText,
                  value: k.cityCode,
                })
              }
            })
          })
        })

        this.home_port = province;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    checkCompName(e) {
      this.editFormData.compName = e.replace('(', '（').replace(')', '）');
    },
    submit() {

    },
    auditAuth(val) {
      this.compAuthVisible = true;
      this.$nextTick(() => {
        this.$refs.compAuth.init(this.userId);
      })
    },
    getOcrBusiness(data) {
      this.$set(this.formData, 'compName', data.danweimingcheng.replace('(', '（').replace(')', '）'));
      this.$set(this.formData, 'taxNum', data.shehuixinyongdaima);
      this.$set(this.formData, 'regAddr', data.dizhi);
      this.$set(this.formData, 'realName', data.faren);
    },
  }
}

</script>
<style scoped>
.block {
  display: flex;
  align-items: center;
}

.block span {
  margin-left: 5px;
  font-size: 15px;
  color: #438df3;
}
</style>